export enum PaymentStatus {
    Pending = 1,
    Paid = 2,
    Rejected = 3,
    Cancelled = 4,
    Failed = 5
}